<template>
    <div>
        <b-card header-class="font-weight-bold">
            <div slot="header">
                <b-button to="/accidents-high" size="sm" variant="secondary" class="float-right">
                    <i class="fa fa-reply fa-lg" /> Volver
                </b-button>
                <div>Concepto PPAM - {{ currentProcess }}</div>
            </div>

            <div class="info-panel mb-3">
                <b-form data-vv-scope="formConcept" @submit.prevent="validateForm()">
                    <b-row class="align-items-end flex-wrap">
                        <template v-if="!isCreateOrFollowProcess || currentProcess === 'Generando seguimiento'">
                            <b-col md="3" sm="6" xs="12" class="mb-3">
                                <div class="info-item d-flex flex-column justify-content-center h-100">
                                    <div class="info-head align-items-center">
                                        <i class="fa fa-industry info-icon" aria-hidden="true"></i>
                                        <div class="info-label">Empresa</div>
                                    </div>
                                    <div class="info-value mt-1 d-flex align-items-center">{{ concept.company ?
                                        concept.company.nombre : 'N/A' }}</div>
                                </div>
                            </b-col>
                            <b-col md="3" sm="6" xs="12" class="mb-1">
                                <div class="info-item d-flex flex-column justify-content-center h-100">
                                    <div class="info-head align-items-center">
                                        <i class="fa fa-map-marker info-icon" aria-hidden="true"></i>
                                        <div class="info-label">Ubicación</div>
                                    </div>
                                    <div class="info-value mt-1 d-flex align-items-center">{{ concept.installation ?
                                        concept.installation : (concept.location ? concept.location.description : 'N/A')
                                        }}</div>
                                    <div class="info-sub d-flex align-items-center">
                                        <span class="mr-1">Ubicación padre:</span>
                                        <b-badge
                                            v-if="concept && (concept.installation || (concept.location && concept.location.parent_location))"
                                            variant="warning" class="px-2 py-1">
                                            {{
                                                concept && concept.installation
                                                    ? (concept.location && concept.location.description ?
                                                        concept.location.description : 'N/A')
                                                    : (concept.location && concept.location.parent_location &&
                                                        concept.location.parent_location.description ?
                                                        concept.location.parent_location.description : 'N/A')
                                            }}
                                        </b-badge>
                                        <b-badge v-else variant="danger" class="px-2 py-1">N/A</b-badge>
                                    </div>
                                </div>
                            </b-col>
                        </template>
                        <template v-else>
                            <b-col md="3" sm="6" xs="12" class="mb-2"
                                v-if="validarPermisoComponente('listar-empresas-concepto-ppam')">
                                <div class="info-head">
                                    <i class="fa fa-industry info-icon" aria-hidden="true"></i>
                                    <div class="info-label">Empresa</div>
                                </div>
                                <div class="mt-1">
                                    <el-select id="company" class="w-100" name="company_id" v-model="concept.company_id"
                                        filterable remote :remote-method="getCompanies" size="medium"
                                        placeholder="Buscar empresa" no-data-text="Sin resultados"
                                        no-match-text="Sin coincidencias" @change="filterLocation" data-vv-as=" "
                                        v-validate="'required'">
                                        <el-option v-for="company in companies" :key="company.id"
                                            :label="company.nombre" :value="company.id" />
                                    </el-select>
                                    <div class="text-danger small" v-text="errors.first('formConcept.company_id')" />
                                </div>
                            </b-col>
                            <b-col md="3" sm="6" xs="12" class="mb-2">
                                <div class="info-head">
                                    <i class="fa fa-map-marker info-icon" aria-hidden="true"></i>
                                    <div class="info-label mr-2">Ubicación</div>
                                    <span class="d-inline-flex align-items-center">
                                        <small class="mr-1">¿No está en la lista?</small>
                                        <b-form-checkbox v-model="concept.location_not_listed" size="sm"
                                            @change="onToggleLocationNotListed" />
                                    </span>
                                </div>
                                <div class="mt-1">
                                    <Treeselect :value="concept.location_id" name="location_id" id="location" clearable
                                        :options="treeWithChildrens" :normalizer="normalizer"
                                        placeholder="Buscar ubicación" :flatten-search-results="true" :multiple="false"
                                        :disable-branch-nodes="false" v-model="concept.location_id"
                                        :defaultExpandLevel="Infinity" no-results-text="No se encontraron resultados."
                                        :max-height="300" class="custom-treeselect"
                                        value-consists-of="ALL_WITH_INDETERMINATE"
                                        noOptionsText="No hay resultados para mostrar" data-vv-as=" "
                                        v-validate="!concept.installation ? 'required' : ''">
                                        <label slot="option-label" slot-scope="{ node, labelClassName }"
                                            :class="labelClassName">
                                            {{ node.label }}
                                        </label>
                                    </Treeselect>
                                    <div class="text-danger small" v-text="errors.first('formConcept.location_id')" />
                                </div>
                            </b-col>
                            <b-col md="3" sm="6" xs="12" class="mb-2" v-if="concept.location_not_listed">
                                <div class="info-head">
                                    <i class="fa fa-info-circle mr-1 info-icon"></i>
                                    <span class="small">Seleccione la ubicación en el listado (si aplica)</span>
                                </div>
                                <div class="mt-1">
                                    <el-input v-model="concept.installation"
                                        placeholder="Escribe el nombre de la ubicación" name="installation"
                                        size="medium" data-vv-as=" " @input="onInstallationInput"
                                        v-validate="!concept.location_id ? 'required' : ''" />
                                    <div class="text-danger small" v-text="errors.first('formConcept.installation')" />
                                </div>
                            </b-col>
                        </template>
                        <b-col md="2" sm="6" xs="12" class="mb-2" v-if="!isCreateOrFollowProcess">
                            <div>
                                <div class="info-head">
                                    <i class="fa fa-check-circle info-icon" aria-hidden="true"></i>
                                    <div class="info-label">Estado</div>
                                </div>
                                <div class="d-flex align-items-center flex-wrap mt-1"
                                    v-if="validarPermisoComponente('cambiar-estado-concepto-ppam') && stateOptions.length > 1">
                                    <el-select v-model="concept.state" placeholder="Estado" size="medium" name="state"
                                        @change="validateForm()" data-vv-as=" " v-validate="'required'"
                                        :disabled="concept.state === 'Creado'">
                                        <el-option v-for="opt in stateOptions" :key="opt.value" :label="opt.label"
                                            :value="opt.value" />
                                    </el-select>
                                    <div class="text-danger small" v-text="errors.first('formConcept.state')" />
                                </div>
                                <div class="d-flex align-items-center flex-wrap mt-1 mb-2" v-else>
                                    <span :class="getStatusClass(concept.state)" class="badge ml-2">{{ concept.state
                                        }}</span>
                                </div>
                            </div>
                        </b-col>
                        <b-col md="2" sm="6" xs="12" class="mb-2">
                            <div>
                                <div class="info-head">
                                    <i class="fa fa-calendar info-icon" aria-hidden="true"></i>
                                    <div class="info-label">Fecha</div>
                                </div>
                                <el-date-picker class="mt-1 w-100" v-model="concept.date" type="date" name="date"
                                    placeholder="Selecciona fecha" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    size="medium" :clearable="true" data-vv-as=" " v-validate="'required'" />
                                <div class="text-danger small" v-text="errors.first('formConcept.date')" />
                            </div>
                        </b-col>
                        <template v-if="!isStateCompleted || isCreateOrFollowProcess">
                            <b-col md="1" sm="6" xs="12" class="mb-2" v-if="isCreateOrFollowProcess">
                                <b-button variant="primary" size="medium" type="submit">
                                    <i class="fa fa-floppy-o mr-1" aria-hidden="true"></i>
                                    Guardar
                                </b-button>
                            </b-col>
                            <b-col md="2" sm="6" xs="12" class="mb-2" v-else>
                                <b-button variant="primary" size="medium" type="submit">
                                    <i class="fa fa-refresh mr-1" aria-hidden="true"></i>
                                    Actualizar
                                </b-button>
                            </b-col>
                        </template>
                    </b-row>
                </b-form>
            </div>

            <!-- FILTROS -->
            <div v-if="!isCreateOrFollowProcess" class="filters-panel mb-4">
                <div class="filters-header mb-3">
                    <h6 class="mb-0 text-muted">
                        <i class="fa fa-filter mr-2"></i>Filtros de búsqueda
                    </h6>
                </div>

                <b-row class="align-items-end">
                    <b-col md="3" lg="3" sm="12" class="mb-3">
                        <b-form-group label="Producto" label-for="search_product" class="mb-0">
                            <b-form-input id="search_product" name="search_product" type="text"
                                placeholder="Buscar producto" v-model="filterProducts.search" class="filter-input" />
                        </b-form-group>
                    </b-col>

                    <b-col md="3" lg="3" sm="12" class="mb-3">
                        <b-form-group label="Fabricante" label-for="manufacturer" class="mb-0">
                            <el-select id="manufacturer" name="manufacturer" placeholder="Buscar fabricante" filterable
                                remote clearable multiple v-model="filterProducts.manufacturers_ids" size="medium"
                                no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                                class="w-100 filter-select" :remote-method="getManufacturers">
                                <el-option v-for="item in manufacturers" :key="item.id" :label="item.nombre"
                                    :value="item.id" />
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="3" lg="3" sm="12" class="mb-3">
                        <b-form-group label="Ubicación" label-for="location_ids" class="mb-0">
                            <Treeselect :value="filterProducts.location_ids" name="location_ids" id="location_ids"
                                clearable :options="treeWithChildrens" :normalizer="normalizer"
                                placeholder="Buscar ubicación" :multiple="true" v-model="filterProducts.location_ids"
                                :defaultExpandLevel="Infinity" no-results-text="No se encontraron resultados."
                                :max-height="300" class="custom-treeselect filter-select"
                                value-consists-of="ALL_WITH_INDETERMINATE"
                                noOptionsText="No hay resultados para mostrar">
                                <label slot="option-label" slot-scope="{ node, labelClassName }"
                                    :class="labelClassName">
                                    {{ node.label }}
                                </label>
                            </Treeselect>
                        </b-form-group>
                    </b-col>

                    <b-col md="3" lg="3" sm="12" class="mb-3">
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label="Cambio en producto" class="mb-0">
                                    <div class="filter-options">
                                        <b-form-checkbox id="productos_con_cambios" v-model="filterProducts.has_changes" switch
                                            size="lg" class="filter-switch">
                                        </b-form-checkbox>
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group label="Solo con capacidades" class="mb-0">
                                    <div class="filter-options">
                                        <b-form-checkbox id="only_with_capacities" v-model="filterProducts.only_with_capacities" switch
                                            size="lg" class="filter-switch">
                                        </b-form-checkbox>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col cols="12" class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="d-flex align-items-center mb-2">
                            <b-button variant="primary" size="sm" @click="getProductsFilters" class="filter-btn mr-2">
                                <i class="fa fa-search mr-1"></i>
                                Buscar
                            </b-button>
                            <b-button variant="outline-secondary" size="sm" @click="clearFilter()" class="filter-btn">
                                <i class="fa fa-eraser mr-1"></i>
                                Limpiar
                            </b-button>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <b-button variant="success" size="sm" @click="showMassManagementModal" class="mass-btn mr-2">
                                <i class="fa fa-cogs mr-1"></i>
                                Gestión masiva
                            </b-button>
                            <b-button variant="info" size="sm" class="results-btn" @click="verifyNotes()">
                                <i class="fa fa-eye mr-1"></i>
                                Ver resultados
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <!-- TABLA -->
            <b-form v-if="!isCreateOrFollowProcess" data-vv-scope="productos">
                <b-table responsive striped bordered hover empty-text="No hay productos para mostrar"
                    thead-tr-class="table-active" show-empty class="mt-3" :items="products.data" :fields="colums">
                    <template v-slot:head(marcar)>
                        <div class="select-header-checkboxes">
                            <el-checkbox v-model="currentPageSelected" size="small">
                                Página
                            </el-checkbox>
                            <el-checkbox v-model="selectAllProducts" @change="toggleSelectAll" size="small">
                                Todo
                            </el-checkbox>
                        </div>
                    </template>

                    <!-- Header personalizado para Capacidad instalada -->
                    <template v-slot:head(installed_capacity)>
                        <div class="d-flex align-items-center">
                            <span>Cap. Max. últimos 5 años / instalada</span>
                            <el-tooltip effect="dark" placement="top" popper-class="py-1 px-2"
                                :content="onlyLastYear ? 'Mostrar todos los años' : 'Mostrar solo último año'">
                                <b-form-checkbox v-model="onlyLastYear" switch size="sm" class="ml-2" />
                            </el-tooltip>
                        </div>
                    </template>

                    <!-- SELECCIÓN -->
                    <template v-slot:cell(marcar)="data">
                        <el-checkbox v-model="data.item.product.high_accident_product_count"
                            @change="setProductSelected({ product: data })" />
                    </template>

                    <template v-slot:cell(name)="data">
                        <span class="font-weight-bold" v-text="data.item.product.nombre"></span>
                        <el-tooltip v-if="data.item.product.snapshot && (data.item.product.snapshot.nombre)"
                            effect="dark" placement="top"
                            :content="tooltipSnapshotContent(data.item.product.snapshot, 'nombre')"
                            popper-class="py-2 px-3">
                            <i class="fa fa-info-circle text-info ml-1" style="cursor:pointer;"></i>
                        </el-tooltip>
                        <br />
                        <span>Fabricante: </span>
                        <span class="badge badge-primary" v-if="data.item.product.fabricante"
                            v-text="data.item.product.fabricante.nombre"></span>
                        <span class="badge badge-danger" v-else>N/A</span>
                        <el-tooltip v-if="data.item.product.snapshot && (data.item.product.snapshot.fabricante)"
                            effect="dark" placement="top"
                            :content="tooltipSnapshotContent(data.item.product.snapshot, 'fabricante')"
                            popper-class="py-2 px-3">
                            <i class="fa fa-info-circle text-info ml-1" style="cursor:pointer;"></i>
                        </el-tooltip>
                        <br />
                        <span v-if="data.item.product.notes && data.item.product.notes.length > 0"
                            class="badge badge-success notes-badge mt-1"
                            @click="openNotesModal(data.item.product, true)" style="cursor: pointer;">
                            Ver notas ({{ data.item.product.notes.length }})
                        </span>
                    </template>

                    <!--  PUNTO DE EBULLICIÓN -->
                    <template v-slot:cell(boiling_point)="data">
                        <b-form-input v-if="data.item.product.properties" type="number" min="1" step="0.01" size="sm"
                            data-vv-as=" " v-model.number="data.item.product.properties.punto_ebullicion"
                            :disabled="isDisabledApproved(data.item.product)"
                            @blur="data.item.product.properties.punto_ebullicion = formatNumberOnBlur(data.item.product.properties.punto_ebullicion)" />
                    </template>

                    <!--  PUNTO DE INFLAMACIÓN -->
                    <template v-slot:cell(flash_point)="data">
                        <b-form-input v-if="data.item.product.properties" type="number" min="1" step="0.01" size="sm"
                            data-vv-as=" " v-model.number="data.item.product.properties.flash_point"
                            :disabled="isDisabledApproved(data.item.product)"
                            @blur="data.item.product.properties.flash_point = formatNumberOnBlur(data.item.product.properties.flash_point)" />
                    </template>

                    <!-- DENSIDAD -->
                    <template v-slot:cell(density)="data">
                        <b-form-input v-if="data.item.product.properties" type="number" min="1" step="0.01" size="sm"
                            data-vv-as=" " v-model.number="data.item.product.properties.densidad"
                            :disabled="isDisabledApproved(data.item.product)"
                            @blur="data.item.product.properties.densidad = formatNumberOnBlur(data.item.product.properties.densidad)" />
                    </template>

                    <!-- CAPACIDAD INSTALADA -->
                    <template v-slot:cell(installed_capacity)="data">
                        <div class="cap-grid"
                            v-if="Array.isArray(data.item.product.installed_capacity) && data.item.product.installed_capacity.length">
                            <div v-for="(cap, idx) in getCapList(data.item.product)" :key="cap.year" class="cap-row">
                                <div class="cap-year">{{ cap.year }}</div>
                                <b-form-input v-model.number="cap.value" type="number" step="0.01" min="0" size="sm"
                                    :disabled="isDisabledApproved(data.item.product) || (currentProcess === 'Detalle de seguimiento' && idx !== getCapList(data.item.product).length - 1)"
                                    class="cap-input" @blur="cap.value = formatNumberOnBlur(cap.value)" />
                                <el-select v-model="cap.list_id" size="small" class="cap-unit"
                                    :disabled="isDisabledApproved(data.item.product) || (currentProcess === 'Detalle de seguimiento' && idx !== getCapList(data.item.product).length - 1)">
                                    <el-option v-for="item in unitMeasures.listas" :key="item.id" :label="item.lista"
                                        :value="item.id" />
                                </el-select>
                            </div>
                        </div>
                    </template>

                    <!-- TEMPRESATURA DE ALMACENAMIENTO -->
                    <template v-slot:cell(storage_temperature)="data">
                        <b-form-input v-if="data.item.product.hasOwnProperty('storage_temperature')" type="number"
                            min="1" step="0.01" :disabled="isDisabledApproved(data.item.product)" size="sm"
                            data-vv-as=" " v-model.number="data.item.product.storage_temperature"
                            @blur="data.item.product.storage_temperature = formatNumberOnBlur(data.item.product.storage_temperature)" />
                    </template>

                    <!-- CONDICION PARTICULAR -->
                    <template v-slot:cell(special_conditions)="data">
                        <b-input-group v-if="data.item.product.hasOwnProperty('special_condition')">
                            <b-form-checkbox v-model="data.item.product.special_condition" name="check-button"
                                :value="1" :unchecked-value="0" :disabled="isDisabledApproved(data.item.product)"
                                size="lg" switch>
                            </b-form-checkbox>
                        </b-input-group>
                    </template>

                    <!-- ACCIONES -->
                    <template v-slot:cell(options)="data">
                        <div class="d-flex justify-content-center">
                            <el-tooltip v-if="validateFollowCount()" effect="dark" placement="top"
                                popper-class="py-1 px-2" content="Guardar">
                                <b-btn v-if="!isStateCompleted" class="mr-1" variant="primary" size="sm"
                                    @click="save(data.item.product)">
                                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                                </b-btn>
                            </el-tooltip>
                            <el-tooltip effect="dark" placement="top" popper-class="py-1 px-2" content="Ver FDS">
                                <b-btn class="" variant="warning" size="sm"
                                    @click="obtainSafetyDataSheets(data.item.product.id)">
                                    <i class="fa fa-file-text-o" aria-hidden="true"></i>
                                </b-btn>
                            </el-tooltip>
                        </div>
                    </template>
                </b-table>

                <b-row>
                    <b-col>
                        <el-pagination class="float-right" style="max-width: 100%" :total="products.total"
                            :current-page="filterProducts.page" :page-size="parseInt(filterProducts.per_page)"
                            @size-change="afterChangeSizePagination" @current-change="afterChangePagePagination"
                            :page-sizes="[10, 30, 50, 100]" layout="total, sizes, prev, pager, next" />
                    </b-col>
                </b-row>

                <ModalFDS v-if="modal_attachments.view" />
            </b-form>
        </b-card>

        <Notes ref="notesModal" :notes="currentProductNotes" :selected-notes="currentProductSelectedNotes"
            :product-name="currentProductData ? currentProductData.nombre : ''" :read-only="notesReadOnly"
            @save="onNotesSelected" @cancel="onNotesCancelled" />

        <b-modal ref="massManagementModal" title="Gestión masiva de productos" size="lg" @hide="onMassManagementCancel"
            :no-close-on-backdrop="true" :no-close-on-esc="true">
            <MassManagement ref="massManagement" :selectedProductsIds="selectedProductsIds"
                :selectAllProducts="selectAllProducts" :canImportExcel="validateCanImport()"
                @cancel="onMassManagementCancel" @file-selected="onFileSelected" @file-cleared="onFileCleared"
                @import-completed="onImportCompleted" />
            <template v-slot:modal-footer>
                <div class="w-100 d-flex justify-content-end gap-2">
                    <b-button variant="danger" @click="onMassManagementCancel">
                        Salir
                    </b-button>
                </div>
            </template>
        </b-modal>

        <b-modal ref="multiProductNotesModal" title="Productos con nota" size="md" @hide="onMultiProductNotesCancel"
            :no-close-on-backdrop="true" :no-close-on-esc="true">
            <MultiProductNotesWizard :products-with-notes="productsWithNotes" @cancel="onMultiProductNotesCancel"
                @completed="onMultiProductNotesCompleted" />
            <template v-slot:modal-footer>
                <div class="w-100 d-flex justify-content-end gap-2">
                    <b-button variant="secondary" @click="onMultiProductNotesCancel">
                        Cerrar
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { validarPermisoComponente } from "@/plugins/acl";
import Treeselect from "@riophae/vue-treeselect";
import ModalFDS from "@/views/accidents_high/ModalFDS.vue";
import MassManagement from "@/views/accidents_high/AccidentsHigh/MassManagement.vue";
import Notes from "@/views/accidents_high/AccidentsHigh/Notes.vue";
import MultiProductNotesWizard from "@/views/accidents_high/AccidentsHigh/MultiProductNotesWizard.vue";

export default {
    name: "WatchProduct",
    components: { Treeselect, ModalFDS, MassManagement, Notes, MultiProductNotesWizard },
    data() {
        return {
            onlyLastYear: false,
            selectedProductsIds: [],
            selectPage: false,
            selectAllProducts: false,
            selectedPages: [],
            hasSelectedFile: false,
            currentProductNotes: [],
            currentProductSelectedNotes: [],
            currentProductData: null,
            notesReadOnly: false,
            colums: [
                { key: "marcar", label: "", sortable: false, thClass: "text-center", tdClass: "text-center", thStyle: { width: "5px" } },
                { key: "name", label: "Producto", sortable: false, thStyle: { width: "300px", "min-width": "300px" } },
                { key: "boiling_point", label: "Punto de ebullición (°C)", sortable: false, thStyle: { width: "115px", "min-width": "115px" } },
                { key: "flash_point", label: "Punto de inflamación (°C)", sortable: false, thStyle: { width: "115px", "min-width": "115px" } },
                { key: "density", label: "Densidad (kg/m³)", sortable: false, thStyle: { width: "110px", "min-width": "100px" }, tdClass: "text-center", thClass: "text-center" },
                { key: "installed_capacity", label: "Capacidad instalada (5 años)", sortable: false, thStyle: { width: "300px", "min-width": "300px" } },
                { key: "storage_temperature", label: "Temperatura de almacenamiento (°C)", sortable: false, thStyle: { width: "140px", "min-width": "140px" } },
                { key: "special_conditions", label: "Cond especial", sortable: false, thStyle: { width: "90px", "min-width": "90px" }, tdClass: "text-left", thClass: "text-left" },
                { key: "options", label: "Acciones", sortable: false, thStyle: "width: 110px; max-width: 120px", tdClass: "text-center", thClass: "text-center" },
            ],
            currentProcess: '',
            validarPermisoComponente: validarPermisoComponente,
            concept: {
                id: null,
                company_id: null,
                location_id: null,
                location_not_listed: false,
                installation: null,
                date: new Date(Date.now() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                state: 'Creado',
                installation: null,
                follow_count: 0,
            }
        };
    },

    computed: {
        ...mapState('aiha', ['companies']),
        ...mapState('location', ['treeWithChildrens']),
        ...mapState('ppam', ['products', 'manufacturers', 'filterProducts', 'productsWithNotes']),
        ...mapState("accidents_high", ['unitMeasures']),
        ...mapState("tareas", ["modal_attachments"]),

        stateOptions() {
            const options = [
                { label: 'Creado', value: 'Creado' },
                { label: 'En proceso', value: 'En proceso' },
                { label: 'Completado', value: 'Completado' },
            ];

            if (!this.validateFollowCount()) {
                return options.filter(o => o.value === 'Completado');
            }

            if (this.concept && (this.concept.state === 'En proceso' || this.concept.state === 'Completado')) {
                return options.filter(o => o.value !== 'Creado');
            }

            return options;
        },

        isCreateOrFollowProcess() {
            return (this.currentProcess === 'Creando concepto' || this.currentProcess === 'Generando seguimiento');
        },

        isStateCompleted() {
            return this.concept.state === 'Completado';
        },

        currentPageSelected: {
            get() {
                return this.selectedPages.includes(this.filterProducts.page);
            },
            set(value) {
                if (value) {
                    this.selectAllProducts = false;
                    this.toggleSelectPage();
                } else {
                    this.toggleSelectPage();
                }
            }
        },
    },

    async mounted() {
        await this.clearFilter('mounted');
        await this.initConcept();
        await this.filterLocation();
    },

    methods: {
        ...mapActions('dashboard', ['obtenerIdEmpresaUsuario']),
        ...mapActions('aiha', ['getCompanies']),
        ...mapActions("location", ["getTreeWithChildrens"]),
        ...mapActions('ppam', ['createConcept', 'getConcept', 'updateConcept',
            'getProducts', 'getManufacturers', 'saveEvaluatedProducts', 'createFollowConcept',
            'updateFollowConcept', 'getVerifyNotes', 'updateNotes']),
        ...mapActions("accidents_high", ['getUnitMeasures']),
        ...mapActions("productos", ["obtainSafetyDataSheets"]),
        ...mapMutations('ppam', ['setFilterProducts', 'setDefaultFilterProducts', 'loadAfterChangeSizePaginationProducts',
            'loadAfterChangePagePaginationProducts', 'setPaginateProducts'
        ]),
        ...mapActions('productos_emp',[
            'getFieldsCustom'
        ]),

        async initConcept() {
            const action = this.$route.query.action;
            const params = this.$route.params;

            this.setCurrentProcess(action);
            this.getUnitMeasures();

            if (!this.validarPermisoComponente('listar-empresas-concepto-ppam')) {
                const company_id = await this.obtenerIdEmpresaUsuario();
                this.concept.company_id = company_id;
            } else if (!this.concept.company_id && params.company_id) {
                this.concept.company_id = params.company_id;
            }

            if (params.id && this.concept.company_id) {
                await this.fetchAndSetConcept(params.id, this.concept.company_id, params.monitoring_id);
            }
        },

        setCurrentProcess(action) {
            const params = this.$route.params;
            if (action === 'follow') {
                this.currentProcess = 'Generando seguimiento';
            } else if (action === 'detail') {
                if (params.id && params.monitoring_id) {
                    this.currentProcess = 'Detalle de seguimiento';
                } else if (params.id) {
                    this.currentProcess = 'Detalle de concepto';
                }
            } else if (!params.id) {
                this.currentProcess = 'Creando concepto';
            }
        },

        filterLocation() {
            if (this.concept.company_id) {
                this.getTreeWithChildrens(this.concept.company_id);
            }
        },

        normalizer(node) {
            return {
                children: node.children && node.children.length ? node.children : 0,
            };
        },

        async validateForm() {
            this.$validator.validateAll("formConcept").then(async (result) => {
                if (result) {
                    if (this.currentProcess == 'Creando concepto') {
                        this.concept.state = 'Creado';
                        const concept = await this.createConcept(this.concept);
                        if (concept.data.id) {
                            this.goTo(concept.data.id);
                        }
                    } else if (this.currentProcess == 'Generando seguimiento') {
                        this.concept.state = 'Creado';
                        const followConcept = await this.createFollowConcept(this.concept);
                        if (followConcept.data.id) {
                            this.goTo(this.concept.id, followConcept.data.id);
                        }
                    } else if (this.currentProcess == 'Detalle de seguimiento') {
                        if (this.$route.params.id && this.$route.params.monitoring_id) {
                            this.updateFollowConcept({ company_id: this.concept.company_id, monitoring_id: this.$route.params.monitoring_id, payload: this.concept });
                            return;
                        }
                    } else if (this.currentProcess == 'Detalle de concepto') {
                        if (this.$route.params.id) {
                            this.updateConcept({ concept_id: this.$route.params.id, company_id: this.concept.company_id, payload: this.concept });
                            return;
                        }
                    }
                }
            });
        },

        async goTo(concept_id, monitoring_id) {
            const company_id = this.concept.company_id;
            const base = `/accidents-high/products/${company_id}/${concept_id}`;

            if (monitoring_id) {
                await this.$router.push(`${base}/${monitoring_id}?action=detail`);
                this.setCurrentProcess('detail');
                this.fetchAndSetConcept(concept_id, company_id, monitoring_id)
                return;
            }

            await this.$router.push(base + '?action=detail');
            this.setCurrentProcess('detail');

            if (concept_id && company_id) {
                await this.fetchAndSetConcept(concept_id, company_id);
            }
        },

        async getProductsFilters(resetPage = true) {
            await this.setFilterProducts({
                company_id: this.concept.company_id,
                search: this.filterProducts.search,
                manufacturers_ids: this.filterProducts.manufacturers_ids,
                ppam_concept_id: this.concept.id,
                ppam_concepts_follow_id: this.concept.monitoring_id,
                parent_location_id: this.concept.location_id,
                location_ids: this.filterProducts.location_ids,
                has_changes: this.filterProducts.has_changes,
                only_with_capacities: this.filterProducts.only_with_capacities
            });
            await this.getProducts(resetPage);
            this.restoreSelectedProducts();
        },

        async clearFilter(calledFrom) {
            this.setDefaultFilterProducts();
            this.selectedPages = [];
            this.selectedProductsIds = [];
            this.selectAllProducts = false;
            if (this.concept.company_id) {
                this.setFilterProducts({ company_id: this.concept.company_id });
                if (calledFrom !== 'mounted') {
                    await this.getProductsFilters();
                }
            }
            this.restoreSelectedProducts();
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePaginationProducts(size);
            this.selectedPages = [];
            await this.getProductsFilters();
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePaginationProducts(page);
            await this.getProductsFilters(false);
            this.restoreSelectedProducts();
        },

        formatNumberOnBlur(val) {
            if (val === null || val === undefined || val === '') return '';
            let num = Number(val);
            if (isNaN(num)) return val;
            num = Math.trunc(num * 100) / 100;
            return Number.isInteger(num) ? num : Number(num.toFixed(2));
        },

        isDisabledApproved(item) {
            return item.high_accident_product_count === true && this.concept.state === "Aprobado";
        },

        restoreSelectedProducts() {
            this.selectedProductsIds = [];
            if (this.products && this.products.data) {
                this.products.data.forEach((row) => {
                    if (!row.product) return;
                    const id = row.product.id || row.id;
                    if (row.product.high_accident_product_count === true) {
                        this.selectedProductsIds.push(id);
                        row.product.high_accident_product_count = true;
                    } else {
                        row.product.high_accident_product_count = false;
                    }
                });
            }
        },

        setProductSelected({ product }) {
            if (product && product.item && product.item.product) {
                this.selectAllProducts = false;
                const currentPage = this.filterProducts.page;
                const idx = this.selectedPages.indexOf(currentPage);
                if (idx !== -1) {
                    this.selectedPages.splice(idx, 1);
                }

                const id = product.item.product.id;
                const checked = !!product.item.product.high_accident_product_count;
                if (checked && !this.selectedProductsIds.includes(id)) {
                    this.selectedProductsIds.push(id);
                } else if (!checked) {
                    const idx = this.selectedProductsIds.indexOf(id);
                    if (idx !== -1) {
                        this.selectedProductsIds.splice(idx, 1);
                    }
                }
            }
        },

        toggleSelectPage() {
            if (!this.products.data || this.products.data.length === 0) return;

            const currentPage = this.filterProducts.page;
            const wasSelected = this.selectedPages.includes(currentPage);
            const isSelected = !wasSelected;

            this.products.data.forEach(item => {
                if (item.product) {
                    const id = item.product.id;
                    item.product.high_accident_product_count = isSelected;

                    if (isSelected && !this.selectedProductsIds.includes(id)) {
                        this.selectedProductsIds.push(id);
                    } else if (!isSelected) {
                        const idx = this.selectedProductsIds.indexOf(id);
                        if (idx !== -1) {
                            this.selectedProductsIds.splice(idx, 1);
                        }
                    }
                }
            });

            if (isSelected) {
                if (!this.selectedPages.includes(currentPage)) {
                    this.selectedPages.push(currentPage);
                }
            } else {
                const idx = this.selectedPages.indexOf(currentPage);
                if (idx !== -1) {
                    this.selectedPages.splice(idx, 1);
                }
            }
        },

        toggleSelectAll() {
            if (this.selectAllProducts) {
                this.selectedPages = [];
                this.selectedProductsIds = [];

                if (this.products.data && this.products.data.length > 0) {
                    this.products.data.forEach(item => {
                        if (item.product) {
                            item.product.high_accident_product_count = false;
                        }
                    });
                }
            }
        },

        async showMassManagementModal() {
            await this.getFieldsCustom(this.concept.company_id);
            this.$refs.massManagementModal.show();
        },

        onMassManagementCancel() {
            this.$refs.massManagementModal.hide();
        },

        onFileSelected() {
            this.hasSelectedFile = true;
        },

        onFileCleared() {
            this.hasSelectedFile = false;
        },

        async onImportCompleted(result) {
            if (result && result.success > 0) {
                await this.getProductsFilters();
            }
        },

        getCapList(item) {
            const caps = Array.isArray(item.installed_capacity) ? item.installed_capacity : [];
            if (this.onlyLastYear) {
                if (!caps.length) return [];
                return [caps.slice().sort((a, b) => b.year - a.year)[0]];
            }
            return caps;
        },

        validateProduct(item) {
            if (!item.storage_temperature) {
                this.$alertError("La temperatura de almacenamiento es obligatoria.", 2500, false, "¡Advertencia!", "info");
                return false;
            }

            if (!item.installed_capacity || !item.installed_capacity.length) {
                this.$alertError("Debe ingresar al menos un año de capacidad instalada.", 2500, false, "¡Advertencia!", "info");
                return false;
            }

            if (
                !item.installed_capacity.length ||
                item.installed_capacity.at(-1) === undefined ||
                item.installed_capacity.at(-1).value === "" ||
                item.installed_capacity.at(-1).value === null ||
                isNaN(Number(item.installed_capacity.at(-1).value))
            ) {
                this.$alertError("El último año de capacidad instalada es obligatorio.", 2500, false, "¡Advertencia!", "info");
                return false;
            }

            if (
                item.installed_capacity.some(cap =>
                    (cap.value !== "" && cap.value !== null && !isNaN(Number(cap.value))) &&
                    (cap.list_id === null || cap.list_id === undefined)
                )
            ) {
                this.$alertError("La unidad de medida es obligatoria para cada año con capacidad instalada.", 2500, false, "¡Advertencia!", "info");
                return false;
            }

            if (
                this.unitMeasures &&
                Array.isArray(this.unitMeasures.listas) &&
                item.installed_capacity.some(cap => {
                    const unidad = this.unitMeasures.listas.find(u => u.id === cap.list_id);
                    return unidad && ['L', 'm³', 'gal', 'Barriles', 'ml'].includes(unidad.lista);
                })
            ) {
                if (!item.properties || item.properties.densidad === null || item.properties.densidad === undefined || item.properties.densidad === "") {
                    this.$alertError("La densidad es obligatoria para unidades de volumen (L, m³, gal, Barriles o ml).", 2500, false, "¡Advertencia!", "info");
                    return false;
                }
            }

            return true;
        },

        async save(item) {
            if (!this.validateProduct(item)) return;
            if (item.notes && item.notes.length > 0) {
                this.currentProductNotes = item.notes;
                this.currentProductSelectedNotes = item.selected_notes || [];
                this.currentProductData = item;
                this.notesReadOnly = false;
                this.$refs.notesModal.show();
                return;
            }

            await this.saveProduct(item);
        },

        async saveProduct(item, selectedNotes = null) {
            if (selectedNotes) {
                item.selected_notes = selectedNotes;
            }

            item.high_accident_product_count = true;
            if (this.currentProcess == 'Detalle de concepto') {
                await this.saveEvaluatedProducts({ concept_id: this.concept.id, company_id: this.concept.company_id, product: item });
            } else if (this.currentProcess == 'Detalle de seguimiento') {
                await this.saveEvaluatedProducts({ concept_id: this.concept.id, company_id: this.concept.company_id, product: item, monitoring_id: this.concept.monitoring_id });
            }
        },

        onNotesSelected(selectedNotes) {
            this.saveProduct(this.currentProductData, selectedNotes);
            this.currentProductNotes = [];
            this.currentProductSelectedNotes = [];
            this.currentProductData = null;
            this.notesReadOnly = false;
        },

        onNotesCancelled() {
            this.currentProductNotes = [];
            this.currentProductSelectedNotes = [];
            this.currentProductData = null;
            this.notesReadOnly = false;
        },

        openNotesModal(product, readOnly = false) {
            this.currentProductNotes = product.notes || [];
            this.currentProductSelectedNotes = product.selected_notes || [];
            this.currentProductData = product;
            this.notesReadOnly = readOnly;
            this.$refs.notesModal.show();
        },

        async fetchAndSetConcept(concept_id, company_id, monitoring_id) {
            const concept = await this.getConcept({ concept_id, company_id, monitoring_id });
            if (concept) {
                this.concept = {
                    location_id: concept.data.location_id,
                    date: concept.data.date,
                    state: concept.data.state,
                    company_id: concept.data.company_id,
                    company: concept.data.company,
                    location: concept.data.location,
                    id: concept.data.id,
                    monitoring_id: concept.data.monitoring_id,
                    installation: concept.data.installation,
                    follow_count: concept.data.follow_count,
                };
                await this.getProductsFilters();
            }
        },

        tooltipSnapshotContent(snapshot, field) {
            let msg = '';
            if (snapshot[field]) {
                msg += `${field.charAt(0).toUpperCase() + field.slice(1)} modificado: ${snapshot[field]}`;
            }
            return msg;
        },

        getStatusClass(status) {
            switch (status) {
                case 'Creado':
                    return 'badge-primary';
                case 'En proceso':
                    return 'badge-en-proceso';
                case 'Completado':
                    return 'badge-completado';
                default:
                    return 'badge-secondary';
            }
        },

        onInstallationInput(val) {
            this.concept.installation = (val || '').toString().toUpperCase();
        },

        onToggleLocationNotListed() {
            this.concept.installation = null;
            this.$validator.reset("formConcept.installation");
        },

        validateFollowCount() {
            return this.concept.follow_count > 0 ? false : true;
        },

        async verifyNotes() {
            await this.getVerifyNotes(this.concept);
            if (this.productsWithNotes && this.productsWithNotes.length > 0) {
                this.showMultiProductNotesModal();
            } else {
                this.goToResults();
            }
        },

        showMultiProductNotesModal() {
            this.$refs.multiProductNotesModal.show();
        },

        onMultiProductNotesCancel() {
            this.$refs.multiProductNotesModal.hide();
        },

        async onMultiProductNotesCompleted(selectedNotesData) {
            this.$refs.multiProductNotesModal.hide();
            if (selectedNotesData && selectedNotesData.length > 0) {
                const data = {
                    company_id: this.concept.company_id,
                    notes: selectedNotesData
                };
                await this.updateNotes(data);
                this.goToResults();
            }
        },

        goToResults() {
            const url = this.concept.monitoring_id
                ? `/accidents-high/results/${this.concept.company_id}/${this.concept.id}/${this.concept.monitoring_id}`
                : `/accidents-high/results/${this.concept.company_id}/${this.concept.id}`;
            this.$router.push(url);
        },

        validateCanImport() {
            if(this.isStateCompleted) return false;
            if(this.validateFollowCount()) return true;
            return false;
        }
    },
};
</script>

<style scoped>
.info-panel {
    background: #f8f9fb;
    border: 1px solid #e9ecef;
    border-radius: 10px;
    padding: 12px 16px;
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px 32px;
    align-items: stretch;
}

.info-item {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    min-width: 220px;
    margin-bottom: 0;
}

.info-icon {
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #17a2b8;
    margin-right: 8px;
}

.info-label {
    font-size: 0.78rem;
    color: #6c757d;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .02em;
}

.info-value {
    font-size: 0.95rem;
    font-weight: 700;
    margin-top: 6px;
    width: 100%;
}

.info-sub {
    margin-top: 4px;
    font-size: 0.85rem;
}

.info-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    grid-column: 1 / -1;
}

.info-head {
    display: flex;
    align-items: center;
}

.cap-grid {
    display: grid;
    grid-template-rows: repeat(5, auto);
    row-gap: 4px;
}

.cap-row {
    display: grid;
    grid-template-columns: 60px 1fr 90px;
    align-items: center;
    column-gap: 6px;
}

.cap-year {
    font-size: 0.75rem;
    color: #6c757d;
    text-align: right;
    padding-right: 4px;
}

.cap-input {
    width: 100%;
}

.cap-unit {
    width: 100%;
}

.badge {
    font-size: 0.7rem;
    padding: 0.4rem 0.6rem;
    border-radius: 0.25rem;
    display: inline-block;
    font-weight: 500;
}

.badge-en-proceso {
    background-color: #ffc107;
    color: #000;
}

.badge-completado {
    background-color: #28a745;
    color: #fff;
}

.filters-panel {
    background: #ffffff;
    border: 1px solid #e3e6f0;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
}

.filters-header {
    border-bottom: 1px solid #e3e6f0;
    padding-bottom: 10px;
}

.filters-header h6 {
    font-weight: 600;
    color: #5a5c69 !important;
}

.filter-input {
    border: 1px solid #d1d3e2;
    border-radius: 6px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.filter-input:focus {
    border-color: #4e73df;
    box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.25);
}

.filter-select {
    border-radius: 6px;
}

.filter-options {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.filter-switch {
    margin-bottom: 0;
}

.filter-switch small {
    margin-left: 8px;
    font-size: 0.75rem;
}

.filter-actions {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.filter-btn {
    width: 100%;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.15s ease-in-out;
}

.filter-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.select-header-checkboxes {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.select-header-checkboxes .el-checkbox {
    margin: 0;
}

.select-header-checkboxes .el-checkbox__label {
    font-size: 0.75rem;
    font-weight: 500;
    color: #6c757d;
}

.filter-btn,
.mass-btn,
.results-btn {
    width: auto;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.15s ease-in-out;
    white-space: nowrap;
    height: 31px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.mass-btn {
    background-color: #28a745;
    border-color: #28a745;
}

.mass-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 0.125rem 0.25rem rgba(40, 167, 69, 0.3);
    background-color: #218838;
    border-color: #1e7e34;
}

.results-btn {
    background-color: #17a2b8;
    border-color: #17a2b8;
    color: #fff;
}

.results-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 0.125rem 0.25rem rgba(23, 162, 184, 0.3);
    background-color: #138496;
    border-color: #117a8b;
}

.notes-badge {
    transition: all 0.2s ease-in-out;
}

.notes-badge:hover {
    background-color: #117a8b !important;
    transform: translateY(-1px);
    box-shadow: 0 0.125rem 0.25rem rgba(23, 162, 184, 0.3);
}

@media (max-width: 768px) {
    .filter-actions {
        flex-direction: row;
        justify-content: center;
    }

    .filter-btn {
        width: auto;
        min-width: 40px;
    }

    .d-flex.align-items-center.justify-content-center {
        flex-direction: column !important;
        gap: 12px;
    }

    .mass-btn {
        margin-right: 0 !important;
        margin-bottom: 0 !important;
        width: 100%;
        max-width: 200px;
    }

    .results-btn {
        margin-bottom: 0 !important;
        width: 100%;
        max-width: 200px;
    }
}
</style>
